import {
  Avatar,
  ETextStyleVariant,
  GeneralRotateCcwIcon,
  GeneralUserUserIcon,
  Text,
} from '@outdoorsyco/bonfire';
import cn from 'classnames';
import React, { memo } from 'react';
import { useIntl } from 'react-intl';

import { getUserInitials } from '@/utility/getUserInitials';

import { useChatbot } from '../../ChatbotProvider';
import { IChatbotMessageProps } from '../ChatbotMessage';

const UserMessage = ({ message, authenticatedUser, index }: IChatbotMessageProps) => {
  const intl = useIntl();
  const { handleResendMessage } = useChatbot();

  const handleResend = () => {
    if (index !== undefined) {
      handleResendMessage(index);
    }
  };

  return (
    <div className="grid grid-cols-[1fr_auto] grid-rows-[auto_auto] gap-2">
      <div className="self-end col-span-1 row-span-1 w-fit justify-self-end">
        <div className="flex flex-col items-start justify-end gap-2">
          {message?.error && (
            <button
              className="flex flex-row items-center justify-start gap-1"
              onClick={handleResend}>
              <GeneralRotateCcwIcon className="text-red-800" width={16} height={16} />
              <Text variant={ETextStyleVariant.LegalRegular} className="text-red-800">
                {intl.formatMessage({
                  defaultMessage: 'Resend message',
                  id: '7ATDyv',
                })}
              </Text>
            </button>
          )}
          <div
            className={cn('p-4 bg-gray-800 rounded-lg w-fit self-end', {
              'bg-red-600': message?.error,
            })}>
            <Text className="text-gray-10">{message.text}</Text>
          </div>
        </div>
      </div>
      <div className="self-end w-fit col-span-1 row-span-1">
        <Avatar
          initials={getUserInitials(authenticatedUser?.first_name, authenticatedUser?.last_name)}
          imageUrl={authenticatedUser?.avatar_url}
          defaultBrandIcon={GeneralUserUserIcon}
          round
        />
      </div>
      <div className="col-span-1 row-span-1 h-fit w-fit justify-self-end">
        {message?.timestamp && (
          <Text variant={ETextStyleVariant.LegalRegular} className="text-right text-gray-50">
            {message.timestamp.toLocaleTimeString([], { hour: 'numeric', minute: 'numeric' })}
          </Text>
        )}
      </div>
    </div>
  );
};

export default memo(UserMessage);
